import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Paper, CircularProgress } from '@material-ui/core';

import HoSoNote from '../../../containers/QCV/HoSo/HoSoNote';
import HoSoViewAdmin from '../../../containers/QCV/HoSo/HoSoViewAdmin';
import { canViewQcvProfile } from '../../../utils/permission';

export default function HoSo() {
	const role = useSelector(state => state.userReducer.user?.role);
	const loading = useSelector(state => state.formReducer.loading);

	// canView: được mở xem hồ sơ người khác (gồm hội đồng bình chọn). Hội đồng
	// xem ĐẦY ĐỦ - cả cột Điểm/Ghi chú lẫn box chấm điểm - nhưng ở chế độ chỉ
	// đọc: HoSoNote tự khoá input & ẩn nút duyệt theo role (xem isQcvCouncil).
	const canView = canViewQcvProfile(role);

	if (!role || loading) return <CircularProgress style={{ marginTop: 128 }} />;

	// Bố cục 2 cột: Chi tiết hồ sơ (trái, cuộn) + box Chấm điểm (phải, dính/sticky
	// khi cuộn). Cột trái cao -> Grid item phải (stretch mặc định) cũng cao, nhờ đó
	// box position:sticky có khoảng chạy theo khi cuộn xuống (không biến mất).
	// Người chỉ được xem thì không có cột phải -> cho cột trái chiếm cả hàng.
	return (
		<Grid item xs={12}>
			<Grid container spacing={3}>
				<Grid item xs={12} lg={9}>
					<Paper className='paper' style={{ marginTop: 32, marginBottom: 16 }}>
						<HoSoViewAdmin canViewOthers={canView} showScoreColumns={canView} />
					</Paper>
				</Grid>
				<Grid item xs={12} lg={3}>
					<Box
						style={{
							position: 'sticky',
							top: 80,
							marginTop: 32,
							maxHeight: 'calc(100vh - 96px)',
							overflowY: 'auto',
						}}
					>
						<HoSoNote />
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
}
